@if (vm) {
    <div class="market-help" [class.market-help--inline]="showInlineInfo">
        @if (marketHelpConfig.marketHelpTextDisplayVersion === markethelpTextDisplayVersion.V1 || showInlineInfo) {
            @if (!showInlineInfo) {
                <span class="info-icon">
                    <vn-icon name="theme-info-i" size="12" />
                </span>
            }
            <div class="market-help-content">
                @if (vm.text) {
                    <div [innerHTML]="vm.text | msTrust: 'html'"></div>
                } @else {
                    <div>{{ noContentMessage }}</div>
                }
                @if (vm.link && vm.href) {
                    <div class="link">
                        <a [href]="vm.href" [attr.target]="vm.target" (click)="track()">{{ vm.link }}</a>
                    </div>
                }
            </div>
        } @else {
            <ms-epcot-notification
                notificationType="info"
                [message]="vm.text ?? noContentMessage"
                [linkValues]="{ link: vm.link, target: vm.target, href: vm.href }"
                (linkClick)="track()" />
        }
    </div>
}
